module.exports = __webpack_public_path__ + "static/media/GalleryMain7.537b9153.jpg";